import classNames from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { GIPHY_TYPE, GALLERY_TYPE, VIDEO_TYPE, containsUrl, IMAGE_TYPE } from 'wix-rich-content-common';
import { getImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { KEYS_CHARCODE } from 'wix-rich-content-editor-common';
import { Image } from 'wix-rich-content-ui-components';
import { s as styles } from '../../anchor-panel-0570bfc1.js';
import { g as LINK_PANEL_ANCHOR_CONTENT } from '../../dataHooks-8eb1301a.js';
import { ANCHORABLE_BLOCKS } from './consts.js';
import '../../style-inject.es-746bb8ed.js';
import '../Icons/AnchorsThumbnails/ParagraphIcon.js';
import '../Icons/AnchorsThumbnails/H1Icon.js';
import '../Icons/AnchorsThumbnails/H2Icon.js';
import '../Icons/AnchorsThumbnails/H3Icon.js';
import '../Icons/AnchorsThumbnails/H4Icon.js';
import '../Icons/AnchorsThumbnails/H5Icon.js';
import '../Icons/AnchorsThumbnails/H6Icon.js';
import '../Icons/AnchorsThumbnails/CodeBlockIcon.js';
import '../Icons/AnchorsThumbnails/BlockQuoteIcon.js';
import '../Icons/AnchorsThumbnails/ImageIcon.js';
import '../Icons/AnchorsThumbnails/GalleryIcon.js';
import '../Icons/AnchorsThumbnails/VideoIcon.js';
import '../Icons/AnchorsThumbnails/MapIcon.js';
import '../Icons/AnchorsThumbnails/ButtonIcon.js';
import '../Icons/AnchorsThumbnails/GiphyIcon.js';
import '../Icons/AnchorsThumbnails/FileIcon.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class AnchorableElement extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "getIconThumbnail", (block) => {
      if (ANCHORABLE_BLOCKS[block.anchorType].thumbnail) {
        return ANCHORABLE_BLOCKS[block.anchorType].thumbnail;
      } else {
        return ANCHORABLE_BLOCKS[block.anchorType][`thumbnail-${block.type}`];
      }
    });
    __publicField(this, "getDataToDisplayByField", (field) => {
      const { block } = this.props;
      if (field === "thumbnail" && ANCHORABLE_BLOCKS[block.anchorType].preview) {
        return this.getPreview();
      } else {
        return ANCHORABLE_BLOCKS[block.anchorType][field];
      }
    });
    __publicField(this, "getContent", () => {
      const { block, t } = this.props;
      if (block.type === "atomic") {
        if (ANCHORABLE_BLOCKS[block.anchorType].preview) {
          return `${t(ANCHORABLE_BLOCKS[block.anchorType].type)} ${block.index}`;
        } else {
          return get(block, ANCHORABLE_BLOCKS[block.anchorType].textPath);
        }
      } else {
        return block.text;
      }
    });
    __publicField(this, "getAbsoluteUrl", (url) => url.substring(0, 4) === "http" ? url : "http://" + url);
    __publicField(this, "getPreview", () => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      const { block } = this.props;
      let src = {};
      switch (block.anchorType) {
        case IMAGE_TYPE:
          src = (_a = block == null ? void 0 : block.data) == null ? void 0 : _a.src;
          break;
        case VIDEO_TYPE:
          if ((_d = (_c = (_b = block == null ? void 0 : block.data) == null ? void 0 : _b.src) == null ? void 0 : _c.thumbnail) == null ? void 0 : _d.pathname) {
            src.file_name = (_g = (_f = (_e = block == null ? void 0 : block.data) == null ? void 0 : _e.src) == null ? void 0 : _f.thumbnail) == null ? void 0 : _g.pathname;
          } else if (containsUrl((_h = block == null ? void 0 : block.data) == null ? void 0 : _h.src)) {
            this.getVideoPreviewUsingNoEmbed(block);
          }
          break;
        case GALLERY_TYPE:
          src.file_name = (_j = (_i = block == null ? void 0 : block.data) == null ? void 0 : _i.items[0]) == null ? void 0 : _j.url;
          break;
        case GIPHY_TYPE:
          this.setState({
            preview: (_l = (_k = block == null ? void 0 : block.data) == null ? void 0 : _k.gif) == null ? void 0 : _l.downsizedUrl
          });
          return;
        default:
          console.error("Mismatch plugins");
          break;
      }
      if (src == null ? void 0 : src.file_name) {
        const imgSrc = getImageSrc(src, null, {
          requiredWidth: 50,
          requiredHeight: 50,
          requiredQuality: 90,
          imageType: "highRes"
        });
        this.setState({
          preview: imgSrc
        });
      }
    });
    __publicField(this, "getVideoPreviewUsingNoEmbed", (block) => {
      const noEmbedBasePath = "https://noembed.com/embed?url=";
      try {
        fetch(`${noEmbedBasePath}${this.getAbsoluteUrl(block.data.src)}`, {
          method: "GET"
        }).then((res) => {
          return res.json();
        }).then((data) => {
          const imgSrc = data.thumbnail_url;
          this.setState({
            preview: imgSrc
          });
        });
      } catch (e) {
        return new Promise((resolve) => {
          setTimeout(() => resolve({}), 1);
        });
      }
    });
    __publicField(this, "previewLoaded", (e) => {
      e.target.style.display = "block";
      this.setState({ iconThumbnail: null });
    });
    __publicField(this, "onKeyDown", (e) => {
      if (e.keyCode === KEYS_CHARCODE.ENTER) {
        this.onClick(e);
        e.preventDefault();
      }
    });
    __publicField(this, "onClick", (e) => {
      this.props.onClick({ defaultName: this.getContent() }, e);
    });
    const { block } = props;
    this.state = { iconThumbnail: this.getIconThumbnail(block) };
  }
  componentDidMount() {
    const { block, blockPreview } = this.props;
    if (!blockPreview && ANCHORABLE_BLOCKS[block.anchorType].preview) {
      this.getPreview();
    }
  }
  render() {
    const { dataHook, isSelected, blockPreview, block, t } = this.props;
    const { iconThumbnail, preview } = this.state;
    const blockPreviewElements = blockPreview == null ? void 0 : blockPreview({
      type: block.anchorType,
      data: block.data,
      text: block.text
    });
    const thumbnailToRender = blockPreviewElements ? /* @__PURE__ */ React.createElement("div", { className: styles.AnchorableElement_thumbnail }, blockPreviewElements.thumbnail) : /* @__PURE__ */ React.createElement(
      Thumbnail,
      {
        iconThumbnail,
        preview,
        alt: this.getContent(),
        previewLoaded: this.previewLoaded,
        id: block.key
      }
    );
    const typeToRender = blockPreviewElements ? blockPreviewElements.type : t(this.getDataToDisplayByField("type"));
    const contentToRender = blockPreviewElements ? blockPreviewElements.content : this.getContent();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        tabindex: "0",
        "data-hook": dataHook,
        className: classNames(styles.AnchorableElement_container, {
          [styles.AnchorableElement_selected]: isSelected
        }),
        onKeyDown: this.onKeyDown,
        onClick: this.onClick
      },
      thumbnailToRender,
      /* @__PURE__ */ React.createElement("div", { className: styles.AnchorableElement_contentContainer }, /* @__PURE__ */ React.createElement("div", { className: styles.AnchorableElement_contentType }, typeToRender), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: styles.AnchorableElement_blockContent,
          "data-hook": LINK_PANEL_ANCHOR_CONTENT
        },
        contentToRender
      ))
    );
  }
}
__publicField(AnchorableElement, "propTypes", {
  dataHook: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  block: PropTypes.object,
  isSelected: PropTypes.bool,
  blockPreview: PropTypes.func
});
class Thumbnail extends PureComponent {
  render() {
    const { iconThumbnail, preview, alt, previewLoaded, id } = this.props;
    const containerId = `${id}-container`;
    return /* @__PURE__ */ React.createElement("div", { className: styles.AnchorableElement_thumbnailContainer }, iconThumbnail && iconThumbnail, preview && /* @__PURE__ */ React.createElement(
      Image,
      {
        id,
        containerId,
        containerProps: {
          containerId,
          className: styles.AnchorableElement_thumbnail
        },
        height: 50,
        width: 50,
        displayMode: "fill",
        uri: preview,
        alt,
        onLoad: (e) => previewLoaded(e)
      }
    ));
  }
}

export { AnchorableElement as default };
//# sourceMappingURL=AnchorableElement.js.map
